import useTranslate from 'modules/local/useTranslate'
import React, {useMemo, useState} from 'react'
import {NullAsDefault} from 'views/Shared'
import {notifyOnError} from "../../factory/createErrorEvent";
import {bindQueryParam} from "../../functions/routerHelper";
import {NotificationActionTypes, successNotify} from "../../factory/createNotification";
import useAsyncAction from "../../../../modules/asyncCache/useAsyncAction";
import CRUD from "../../../Shared/enums/CRUD";
import {Modal} from "antd";
import {DelayRender} from "../../../Shared/components/DelayRender";
import ParishContext, {ParishProvider} from "../ParishContext";
import {parish_createParish_Api, parish_deleteParish_Api, parish_updateParish_Api} from "../../../../apis";
import {DetailViewForm} from "../components/ParishForm";
import LoadingBlock from "../../../Loading/LoadingBlock";


export const useParishes = ({
                                notifyListeners = {
                                    onCreated: undefined,
                                    onUpdated: undefined,
                                    onDeleted: undefined,
                                },
                            }) => {
    const t = useTranslate()
    const [action, setAction] = useState({type: undefined, value: undefined})

    const {
        onCreated = NullAsDefault,
        onUpdated = NullAsDefault,
        onDeleted = NullAsDefault,
    } = notifyListeners ?? {}

    const onError = notifyOnError(t)

    const {handleAsyncAction: onCreate, ...asyncCreating} = useAsyncAction({
        onError,
        query: bindQueryParam({}),
        apiInfo: parish_createParish_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.CREATE, t)
            onCreated(result, data)
        },
    })

    const {handleAsyncAction: onUpdate, ...asyncUpdating} = useAsyncAction({
        onError,
        apiInfo: parish_updateParish_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onUpdated(result, data)
        },
    })

    const {handleAsyncAction: onDelete, ...asyncDeleting} = useAsyncAction({
        onError,
        apiInfo: parish_deleteParish_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.DELETE, t)
            onDeleted(result, data)
        },
    })

    const handleAction = (action, params) => {
        switch (action) {
            case CRUD.READ:
                setAction({type: action, value: params})
                break
            default:
                break
        }
    }
    const onCancel = () => {
        setAction({})
    }
    const showDialog = (params) => {
        return handleAction(CRUD.READ, params)
    }

    const parishModal = useMemo(() => {
        let Content = NullAsDefault
        let Wrapper = ({children}) => children({initialValues: {}})
        let params = {initValues: {...action.value}}
        let modal_params = {}
        switch (action.type) {
            case CRUD.READ:
                params = {}
                modal_params = {
                    width: 600,
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('parish information')}
                        </div>
                    ),
                }
                Content = ({...rest}) => (
                    <ParishProvider item={action.value}>
                        <ParishContext.Consumer>
                            {({item}) => {
                                return (
                                    <DetailViewForm
                                        {...rest}
                                        item={item}
                                        reportAccess={false}
                                    />
                                )
                            }}
                        </ParishContext.Consumer>
                    </ParishProvider>
                )
                break
            default:
                break
        }

        return (
            <Modal
                className="custom-modal"
                footer={null}
                onCancel={onCancel}
                open={action.type && action.type !== CRUD.DELETE}
                destroyOnHidden={true}
                {...modal_params}>
                <DelayRender lazy={true}>
                    <Wrapper>
                        {({isLoading, initialValues}) => {
                            if (!!isLoading) {
                                return <LoadingBlock/>
                            }
                            return (
                                <Content
                                    {...{
                                        onCancel,
                                        item: action.value,
                                    }}
                                    {...params}
                                    initialValues={initialValues}
                                />
                            )
                        }}
                    </Wrapper>
                </DelayRender>
            </Modal>
        )
    }, [action])

    return {
        onCreate,
        onUpdate,
        onDelete,
        asyncCreating,
        asyncUpdating,
        asyncDeleting,
        parishModal,
        showDialog
    }
}



